import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { messaging } from "./firebase/config";

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('Starting React app render');
root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);

console.log('React app rendered successfully');

// Register service worker for PWA functionality
serviceWorkerRegistration.register();

// Register FCM service worker for push notifications
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      if (messaging && messaging.useServiceWorker) {
        messaging.useServiceWorker(registration);
      }
      console.log("✅ FCM Service Worker registered");
    })
    .catch((err) => {
      console.error("❌ FCM Service Worker error", err);
    });
}

// If you want your app to work offline and load faster, you can change
